import * as S from "./InputFileList.style";
import { InputProps } from "..";
import { ColDef } from "ag-grid-community";
import { Control, Controller } from "react-hook-form";
import { ChangeEvent, useRef, useState } from "react";
import { Buttons } from "../../Buttons";
import { Grid } from "../../../molecules/Grid";

interface ControlFileProps extends InputProps {
  control: Control<any>;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const InputFileList = ({ name, width, control }: ControlFileProps) => {
  const [files, setFiles] = useState<File[]>([]);
  const gridApiRef = useRef<any>(null);

  const columnDefs: ColDef[] = [
    {
      width: 52,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      width: 448,
      field: "name",
      headerName: "파일명",
    },
  ];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState }) => {
        const deleteReportData = () => {
          if (gridApiRef.current) {
            const rowData = gridApiRef.current.getSelectedRows();
            const selectedFileNames = rowData.map((row: any) => row.name);

            setFiles((prevFiles) => {
              const updatedFiles = prevFiles.filter(
                (file) => !selectedFileNames.includes(file.name)
              );
              field.onChange(updatedFiles);
              return updatedFiles;
            });
          }
        };

        return (
          <>
            <S.InputFileListBox width={width}>
              <S.InputFileListHeader>
                파일
                <S.InputFileListButtons>
                  <Buttons
                    type="button"
                    size="sm"
                    layout="destructive"
                    label="선택삭제"
                    onClick={deleteReportData}
                  />
                  <S.InputFileListLabel>
                    파일등록
                    <input
                      name={name}
                      type="file"
                      multiple
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        if (e.target.files) {
                          const newFiles = Array.from(e.target.files);
                          setFiles((prevFiles) => {
                            const updatedFiles = [...prevFiles, ...newFiles];
                            field.onChange(updatedFiles);
                            return updatedFiles;
                          });
                        }
                      }}
                    />
                  </S.InputFileListLabel>
                </S.InputFileListButtons>
              </S.InputFileListHeader>

              <S.InputFileList>
                <Grid
                  rowData={files}
                  columnDefs={columnDefs}
                  paging={false}
                  rowSelection={"multiple"}
                  onGridReady={(params) => {
                    gridApiRef.current = params.api;
                  }}
                />
              </S.InputFileList>
            </S.InputFileListBox>
          </>
        );
      }}
    />
  );
};
